<template>
    <div @keyup.ctrl.70.prevent="route = 'search'" @keyup.esc.exact="route = 'node'" class="org" tabindex="1">
        <slot name="before" />

        <div v-if="route === 'node'">
            <a @click="route = 'search'" href="javascript:;" class="icon">
                🔍
            </a>

            <a v-if="route === 'node'" @click="route = 'agenda'" href="javascript:;" class="icon">
                📅
            </a>

            <a v-if="app.connection" @click="app.refresh()" href="javascript:;" :class="'icon refresh-icon ' + (app.isReloading ? 'spin' : '')">
                ↺
            </a>
        </div>

        <div v-else>
            <a @click="route = 'node'" href="javascript:;" class="icon">
                <span class="close">×</span>
            </a>
        </div>

        <search
            v-if="route === 'search'"
            :rootNode="rootNode"
            :app="app"
            :toggler="toggler"
        />

        <agenda
            v-if="route === 'agenda'"
            :rootNode="rootNode"
            :app="app"
            :toggler="toggler"
        />

        <node
            v-if="route === 'node'"
            :node="rootNode"
            :app="app"
        />

        <slot name="after" />
    </div>
</template>

<script>
import Node    from '../node/component.vue';
import Search  from '../search/component.vue';
import Agenda  from '../agenda/component.vue';

export default {
    props: ['app', 'rootNode'],

    components: {
        Agenda,
        Node,
        Search
    },

    data() {
        var _ = this;

        return {
            toggler: _,
            route: 'node'
        };
    },

    methods: {
        toggle(node) {
            var _ = this;

            _.route = 'node';

            _.app.closeDescendents(_.rootNode);
            _.app.expandAncestry(node);
            _.app.expandNode(node);
            _.app.highlightNode(node);
        }
    }
};
</script>
